module.exports = __webpack_public_path__ + "img/mercadopago4.18b0cebf.jpg";